import { apiRoutes } from '@/app/apiConfig/apiRoutes';
import { apiSlice } from './apiSlice';
import { Stage } from '../shared-components/Types/Stages';
import { Paged } from '../shared-components/Types/Paged';

export const stagesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStages: builder.query<Paged<Stage>, void>({
      query: () => ({ url: apiRoutes.stages, method: 'GET' }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetStagesQuery } = stagesApiSlice;
